import axios from "axios";
import {
    CREATE_FORKLIFT,
    CREATE_FORKLIFT_REQUEST,
    CREATE_FORKLIFT_FAIL,
    SUBMIT_FORKLIFT,
    SUBMIT_FORKLIFT_REQUEST,
    SUBMIT_FORKLIFT_FAIL,
    UPDATE_FORKLIFT,
    UPDATE_FORKLIFT_REQUEST,
    UPDATE_FORKLIFT_FAIL,
    SET_FORKLIFT_DRAFT,
    SET_FORKLIFT_DRAFT_REQUEST,
    SET_FORKLIFT_DRAFT_FAIL,
    SET_FORKLIFT_SERVICED,
    SET_FORKLIFT_SERVICED_REQUEST,
    SET_FORKLIFT_SERVICED_FAIL,
    GET_FORKLIFT,
    GET_FORKLIFT_REQUEST,
    GET_FORKLIFT_FAIL,
    GET_FORKLIFTS,
    GET_FORKLIFTS_REQUEST,
    GET_FORKLIFTS_FAIL,
    GET_FORKLIFTS_BY_USER,
    GET_FORKLIFTS_BY_USER_REQUEST,
    GET_FORKLIFTS_BY_USER_FAIL,
    GET_FORKLIFTS_BY_LOCATION,
    GET_FORKLIFTS_BY_LOCATION_REQUEST,
    GET_FORKLIFTS_BY_LOCATION_FAIL,
    DELETE_FORKLIFT,
    DELETE_FORKLIFT_REQUEST,
    DELETE_FORKLIFT_FAIL,

} from "../types/forkliftTypes"

const token = localStorage.getItem("token:data");
export const createInspection = (forklift) => async (dispatch) => {
    
    try {
        dispatch({
            type: CREATE_FORKLIFT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.post(`/api/v1/forklift/inspection`, forklift, config);
        dispatch({
            type: CREATE_FORKLIFT,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: CREATE_FORKLIFT_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}

export const submitInspection = (forklift) => async (dispatch) => {
    
    try {
        dispatch({
            type: SUBMIT_FORKLIFT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.post(`/api/v1/forklift/inspection/submit`, forklift, config);
        dispatch({
            type: SUBMIT_FORKLIFT,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: SUBMIT_FORKLIFT_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}


export const updateInspection = (forklift) => async (dispatch) => {
    
    try {
        dispatch({
            type: UPDATE_FORKLIFT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/forklift/inspection/${forklift.id}`, forklift, config);
        dispatch({
            type: UPDATE_FORKLIFT,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: UPDATE_FORKLIFT_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}

export const setInspectionDraft = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: SET_FORKLIFT_DRAFT_REQUEST
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/forklift/inspection/draft/${id}`, null, config);
        dispatch({
            type: SET_FORKLIFT_DRAFT,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: SET_FORKLIFT_DRAFT_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request 
                ? error.request.data.error
                : error.message,
        });
    }
}

export const setInspectionServiced = (service) => async (dispatch) => {
    
    try {
        dispatch({
            type: SET_FORKLIFT_SERVICED_REQUEST
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/forklift/inspection/serviced/${service.id}`, service, config);
        dispatch({
            type: SET_FORKLIFT_SERVICED,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: SET_FORKLIFT_SERVICED_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request 
                ? error.request.data.error
                : error.message,
        });
    }
}


export const getInspections = () => async (dispatch) => {
    
    try {
        dispatch({
            type: GET_FORKLIFTS_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.get(`/api/v1/forklift/inspections`, config);
        dispatch({
            type: GET_FORKLIFTS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_FORKLIFTS_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
                });
    }
}

export const getInspection = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: GET_FORKLIFT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.get(`/api/v1/forklift/inspection/${id}`, config);
        dispatch({
            type: GET_FORKLIFT,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_FORKLIFT_FAIL,
            payload:
                error.response && error.response.data?.error
                ? error.response.data?.error
                : error.request
                ? error.request.data?.error
                : error.message,
        });
    }
}

export const getInspectionsByUser = () => async (dispatch) => {
   
    try {
        dispatch({
            type: GET_FORKLIFTS_BY_USER_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let { data } = await axios.get(`/api/v1/forklift/myinspections/user`, config);
        dispatch({
            type: GET_FORKLIFTS_BY_USER,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_FORKLIFTS_BY_USER_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}


export const getInspectionsByLocation = (id) => async (dispatch) => {
   
    try {
        dispatch({
            type: GET_FORKLIFTS_BY_LOCATION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let { data } = await axios.get(`/api/v1/forklift/inspections/location/${id}`, config);
        dispatch({
            type: GET_FORKLIFTS_BY_LOCATION,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_FORKLIFTS_BY_LOCATION_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

export const deleteInspection = (id) => async (dispatch) => {
    try {
        dispatch({
            type: DELETE_FORKLIFT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        await axios.delete(`/api/v1/forklift/inspection/${id}`, config);
        dispatch({
            type: DELETE_FORKLIFT,
        });
    } catch (error) {
        dispatch({
            type: DELETE_FORKLIFT_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

